import axios from 'axios'
import { checkCandidateAccess } from '../../utils/utils'

/**
 * API for making token active for a particular session
 * @returns Empty Response
 */
export const tokenActive = async () => {
  const response = await axios.get(
    checkCandidateAccess() ? 'candidates/heartbeat' : 'auth/heartbeat'
  )
  return response
}

/**
 *
 * @param {string} challengeTypeId
 * @returns Get all Testcase Types
 */
export const getTestcaseTypes = async (challengeTypeId) => {
  const response = await axios.get(
    `testcases/types?challengeTypeId=${challengeTypeId}`
  )
  return response
}

/**
 *
 * @returns return user ip address
 */
export const getIpDetails = async () => {
  const response = await axios.get(`ip-location`)
  return response
}

/**
 *
 * @returns return user ip address
 */
export const getClientIp = async () => {
  const response = await axios.get(`ip-location`)
  return response
}

/**
 *
 * @returns
 */
export const generateApiKeyCall = async () => {
  const response = await axios.post(`keys/generate`)
  return response
}

/**
 *
 * @returns
 */
export const getApiKey = async () => {
  const response = await axios.get(`keys`)
  return response
}
